export enum ModalResult {
  none = 0,
  primary = 1,
  secondary = 2,
  negative = 3,
}
